import React from 'react';
import { Link } from 'react-router-dom';

/**
 * TermsOfService - Minimal, clean design
 */
function TermsOfService() {
  return (
    <div className="min-h-screen bg-gray-50 py-4 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
          <p className="text-sm text-gray-500">Last updated: January 11, 2026</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-xl border border-gray-200 p-6 md:p-8 space-y-6 text-gray-700 text-sm leading-relaxed">

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Service</h2>
            <p>
              MidoLABS.ai is an AI model comparison platform. We provide tools to compare outputs from multiple AI models side-by-side.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">2. Account</h2>
            <ul className="space-y-1">
              <li>• You must be 13+ years old (16+ in EU)</li>
              <li>• Keep your password secure</li>
              <li>• You're responsible for activity under your account</li>
              <li>• We may suspend accounts that violate these terms</li>
            </ul>
          </section>

          <section className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">3. Community Guidelines</h2>
            <p className="mb-2">When using our community features (comments, public benchmarks):</p>
            <ul className="space-y-1 text-gray-800">
              <li>✓ Be respectful and use appropriate language</li>
              <li>✓ Keep discussions relevant and constructive</li>
              <li>✓ Respect other users and their opinions</li>
              <li>✗ No hate speech, harassment, or discrimination</li>
              <li>✗ No spam, advertising, or promotional content</li>
              <li>✗ No sharing of personal information of others</li>
              <li>✗ No offensive, vulgar, or inappropriate content</li>
            </ul>
          </section>

          <section className="bg-red-50 border border-red-200 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Prohibited Uses</h2>
            <p className="mb-2">Do not use MidoLABS.ai to:</p>
            <ul className="space-y-1 text-gray-800">
              <li>✗ Generate illegal or harmful content</li>
              <li>✗ Violate intellectual property rights</li>
              <li>✗ Hack or compromise our systems</li>
              <li>✗ Scrape or automatically access our service</li>
              <li>✗ Resell access without permission</li>
            </ul>
          </section>

          <section className="bg-amber-50 border border-amber-200 rounded-lg p-4">
             <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Account Suspension</h2>
            <p className="mb-2">
              By creating an account, you agree that MidoLABS.ai administrators reserve the right to:
            </p>
            <ul className="space-y-1 text-gray-800">
              <li>• Suspend or terminate accounts that violate these Terms of Service or Community Guidelines</li>
              <li>• Remove content that violates our policies without prior notice</li>
              <li>• Take action at their sole discretion to maintain platform safety</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Content</h2>
            <ul className="space-y-1">
              <li>• You own your prompts and can make results public/private</li>
              <li>• AI outputs are generated by third-party providers</li>
              <li>• We don't guarantee accuracy of AI responses</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Limitations</h2>
            <ul className="space-y-1">
              <li>• Service provided "as is" without warranties</li>
              <li>• We're not liable for AI-generated content</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">8. Third Parties</h2>
            <p>
              We use OpenAI, Anthropic, Google, and more AI Providers for AI services.
              Their terms and privacy policies also apply.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">9. Changes</h2>
            <p>
              We may update these terms. Continued use after changes means you accept them.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">10. Governing Law</h2>
            <p>
              These terms are governed by the laws of Israel. Disputes will be resolved through arbitration.
            </p>
          </section>

          <div className="pt-4 border-t border-gray-200 text-center text-gray-600">
            By using MidoLABS.ai, you agree to these Terms of Service.
          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-6 text-center text-sm text-gray-500">
          <Link to="/privacy" className="hover:text-blue-600">Privacy</Link>
          <span className="mx-2">•</span>
          <Link to="/" className="hover:text-blue-600">Home</Link>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;